import React, { useEffect, useState } from "react";
import {
   Container,
//   Grid,
  Button,
  Typography,
  Box,
} from "@mui/material";

import ProductForm from "./Products/ProductForm";
import ProductDetail from "./Products/ProductDetail";
import ConfirmDialog from "./Products/ConfirmDialog";
import ProductCard from "./Products/ProductCard";
import {
  getProducts,
  createProduct,
  updateProduct,
  deleteProduct,
} from "../api/productApi";


const ProductPage = () => {
  const [products, setProducts] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const fetchProducts = async () => {
    const res = await getProducts();
    setProducts(res.data);
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleSubmit = async (data) => {
    if (editData) {
      await updateProduct(editData._id, data);
    } else {
      await createProduct(data);
    }

    fetchProducts();
    setOpenForm(false);
    setEditData(null);
  };

  const handleDelete = async () => {
    await deleteProduct(deleteId);
    fetchProducts();
    setDeleteId(null);
  };

  return (
 <Container maxWidth="xl" sx={{ mt: 6, mb: 6 }}>

  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    mb={4}
  >
    <Typography variant="h4" fontWeight={600}>
      Product Management
    </Typography>

    <Button
      variant="contained"
      onClick={() => setOpenForm(true)}
    >
      Add Product
    </Button>
  </Box>

  {/* CSS GRID FIXED 3 COLUMNS */}
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",         // mobile
        sm: "repeat(2,1fr)", // tablet
        md: "repeat(3,1fr)"  // desktop → 3 per row
      },
      gap: 4,
    }}
  >
    {products.map((product) => (
      <ProductCard
        key={product._id}
        product={product}
        onEdit={(p) => {
          setEditData(p);
          setOpenForm(true);
        }}
        onDelete={(id) => setDeleteId(id)}
        onView={(p) => setViewProduct(p)}
      />
    ))}
  </Box>



 <ProductForm
        open={openForm}
        handleClose={() => {
          setOpenForm(false);
          setEditData(null);
        }}
        handleSubmit={handleSubmit}
        editData={editData}
      />

      <ProductDetail
        open={Boolean(viewProduct)}
        handleClose={() => setViewProduct(null)}
        product={viewProduct}
      />

      <ConfirmDialog
        open={Boolean(deleteId)}
        handleClose={() => setDeleteId(null)}
        handleConfirm={handleDelete}
      />


</Container>


  );
};

export default ProductPage;

